module.exports = __webpack_public_path__ + "static/media/phone.58edbe76.svg";